/** Default platform logo (TradeTitans) */
export const DEFAULT_APP_LOGO =
  'https://storage.googleapis.com/hostinger-horizons-assets-prod/d320fc03-def5-4f91-8dbd-38a9467ba9b0/8d26271ab1fccca4ffe8c0f2f245f9da.png';

function customLogo(url?: string | null): string | null {
  if (!url || url === DEFAULT_APP_LOGO) return null;
  return url;
}

export function resolveSidebarLogo(
  tenant?: { logo_url?: string | null } | null,
  profile?: { logo_url?: string | null } | null
): string {
  return customLogo(tenant?.logo_url) || customLogo(profile?.logo_url) || DEFAULT_APP_LOGO;
}

export const LOGO_ACCEPT = 'image/png,image/jpeg,image/gif,image/webp,image/svg+xml';
export const LOGO_MAX_BYTES = 2 * 1024 * 1024;